// alternative-dashboard/mappers/spendCategoryMapper.ts
import type { DashboardSpendCategoryResponse } from "@/app/types/alterNativeDashboardLayout";

export interface SpendCategoryChartPoint {
  name: string;
  value: number;
  color: string;
}

export interface SpendCategoryUIModel {
  chartData: SpendCategoryChartPoint[];
  totalAmount: number;
  currency: string;
}

const KNOWN_CATEGORY_COLORS: Record<string, string> = {
  "Vendor payments": "#2B4DED",
  Payroll: "#D353D1",
  Utilities: "#32B2BC",
  "Cards & fees": "#FFBCA7",
};
const FALLBACK_COLOR_PALETTE = [
  "#2B4DED",
  "#D353D1",
  "#32B2BC",
  "#FFBCA7",
  "#8E44AD",
  "#16A085",
];

const getCategoryColor = (categoryName: string, index: number): string =>
  KNOWN_CATEGORY_COLORS[categoryName] ??
  FALLBACK_COLOR_PALETTE[index % FALLBACK_COLOR_PALETTE.length];

export const mapSpendCategoryResponse = (
  response: DashboardSpendCategoryResponse | undefined,
  fallbackCurrency: string,
): SpendCategoryUIModel => {
  const categories = response?.categories ?? [];

  const chartData: SpendCategoryChartPoint[] = categories.map(
    (item, index) => ({
      name: item.category,
      value: item.percentage,
      color: getCategoryColor(item.category, index),
    }),
  );

  return {
    chartData,
    totalAmount: response?.totalAmount ?? 0,
    currency: response?.currency ?? fallbackCurrency,
  };
};

